// ApiService.ts
import axios, { AxiosInstance } from "axios";
import { baseURl } from "./Config";

const apiClient: AxiosInstance = axios.create({
  baseURL: baseURl, 
  headers: {
    "Content-Type": "application/json",
  },
});

// Generic GET request
const get = async <T>(url: string): Promise<T | null> => {
  try {
    const response = await apiClient.get<T>(url);
    return response.data;
  } catch (error) {
    console.error(`Error fetching data from ${url}:`, error);
    return null;
  }
};

// Generic POST request
const post = async <T>(url: string, data: any): Promise<T | null> => {
  try {
    const response = await apiClient.post<T>(url, data);
    return response.data;
  } catch (error) {
    console.error(`Error posting data to ${url}:`, error);
    return null;
  }
};

export const ApiService = {
  get,
  post,
};
